/* global $ */
/* global URLS */
/* global gettext */

/**
 * @todo Disable add to cart if error
 */
(function (sculpteo) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintController} controller
   * @param {Design} design
   */
  var PrintPriceView = (sculpteo.PrintPriceView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;
    this.design.order.production_mode = this.design.order.production_mode || ""; // TODO: looks strange, check this

    this.$el = $(".PrintPriceView");

    this.$el.on(
      "click",
      ".add-to-cart-button",
      this.ReviewAndAddToCart.bind(this)
    );

    this.$el.on(
      "click",
      ".price:not(.errors)",
      function (event) {
        this.selectProductionMode($(event.currentTarget).data("mode"));
      }.bind(this)
    );

    this.$el.on(
      "change",
      ".price-currency-selector",
      this.currencySelected.bind(this)
    );

    $(".price-currency-selector-container > .price-currency-selector")
      .select2({
        width: "3em",
        minimumResultsForSearch: -1,
      })
      .on("select2:close", function (e) {
        $(".toggle-select-currency", this.$el).show();
        $(".price-currency-selector-container", this.$el).hide();
      });
    this.$el.on(
      "click",
      ".toggle-select-currency",
      { displaySelect: true },
      this.toggleCurrencyDisplay.bind(this)
    );

    this.$el.on("click", ".quote-button", this.getQuoteForm.bind(this));

    sculpteo.PrintQuantityDecorator.call(this, this.$el);
  });

  // Let's decorate a bit. Quantity methods are common with the multi print page, so they've been moved to another file.
  PrintPriceView.prototype = $.extend(
    PrintPriceView.prototype,
    sculpteo.PrintQuantityDecorator.prototype
  );

  /**
   * Toggle "usability" of the view by adding a gray layer upon it.
   * @param {bool} enabled
   */
  PrintPriceView.prototype.enabled = function (enabled) {
    this.$el.toggleClass("disabled", !enabled);
  };

  /**
   * Controller callback for updated prices
   * @public
   * @param {object} prices
   */
  PrintPriceView.prototype.updatePrices = function (prices) {
    this.prices = prices;

    // Make sure we take into account any material/currency change in the server response
    // This is especially useful on first load, and if you are coming from the multiprint page (advanced settings)
    this.currencyChanged();

    this.render();
  };

  PrintPriceView.prototype._overrideProductionModeErrors = function (
    production_mode,
    errors_in
  ) {
    // Override errors. Disabling a mode under certain condition can be done by overriding the errors array
    // This should ideally be done for things that can't be done server side

    var errors = errors_in.map(function (x) {
      return x;
    }); // Not sure we need the copy

    if (!errors) errors = [];

    // We disallow economy_mode for PA12 Dyed with color touch/resist
    if (
      production_mode == "economy_mode" &&
      [
        "hp_plastic,pa_12_hp,dyemansion_lunettes,black",
        "hp_plastic,pa_12_hp,dyemansion_outdoor,black",
      ].includes(this.design.currentMaterial)
    ) {
      errors.push("Not available for this configuration");
    } else if (
      // Disallow express and eco mode for finishes and painting
      // Allow express mode for SLA (hand_polished finish is the default for this material)
      // Allow eco mode for PA11 polished finish
      // I Disabled eco mode for PA11 with options != polished
      production_mode !== PRODUCTION_MODE.STANDARD &&
      (this.design.order.finish || this.design.order.painting) &&
      this.design.material.slug != "prototyping_resin_white_formlabs" && // SLA
      !(
        this.design.material.slug == "pa11_sls" &&
        (this.design.order.finish == "polished" || !this.design.order.finish)
      ) // polished or not  pa11
    ) {
      errors.push("Not available for this configuration"); // FIXME: should be the message about 'express and eco only avail with pa12'
    }

    return errors;
  };

  PrintPriceView.prototype.selectProductionMode = function (mode) {
    if (mode == "standard_mode")
      // TODO: get rid of this
      mode = "";

    this.controller.updateProductionMode(mode);
    this.render();
  };

  /**
   * Currency clicked DOM callback
   * @private
   */
  PrintPriceView.prototype.currencySelected = function (event) {
    var currency = $(event.currentTarget).val();
    var symbol = this._getCurrencySymbol(currency);
    if (!symbol) {
      return;
    }
    this.controller.updateCurrency(currency, symbol);
  };

  /**
   * Updated currency controller callback
   * @private
   */
  PrintPriceView.prototype.currencyChanged = function () {
    // Some production modes become unavailable when changing currency, autoswitch if necessary
    var currentMode = this.getSelectedMode();
    if (this.design.order.currency == "USD" && currentMode == "fast_mode") {
      console.log(
        "Autoswitch to standard_mode, current mode not avalaible with currency ",
        this.design.order.currency
      );
      this.selectProductionMode("standard_mode");
      return;
    }

    this.render();
  };

  PrintPriceView.prototype.getSelectedMode = function () {
    return this.design.order.production_mode || "standard_mode";
  };

  /**
   * if the model is fragile we're displaying the modal review
   * else we add to cart
   * @param {bool} disabled
   */
  PrintPriceView.prototype.ReviewAndAddToCart = function (e) {
    // cannot add to cart if we have errors
    var hasErrors =
      PriceDataUtils.getErrors(this.prices, this.getSelectedMode()).length > 0;
    if (hasErrors) {
      return;
    }

    if (
      this.controller.checkError(sculpteo.ERROR.SOLIDITY_WILL_BREAK) ||
      this.controller.checkError(sculpteo.ERROR.SOLIDITY_MAY_BREAK) ||
      (this.controller.checkWarning(sculpteo.WARNING.SOLIDITY_MAY_BREAK) &&
        (this.controller.controllerType == "2D" ||
          this.controller.controllerType == "3D"))
    ) {
      this.controller.toggleModalReview();
    } else {
      this.controller.addToCart();
    }
  };

  /**
   * @private
   */
  PrintPriceView.prototype.localisationChanged = function (event) {
    var new_loc = $(event.currentTarget).context.selectedOptions[0].label;
    var continent = $(event.currentTarget).val();

    $(".toggle-select-localisation a", this.$el).html(gettext(new_loc));
    var old_currency = $(
      ".price-currency-selector option:selected",
      this.$el
    ).val();
    var new_currency = old_currency;
    if (continent == "EU") {
      if (new_loc == "United Kingdom of Great Britain and Northern Ireland")
        new_currency = "GBP";
      else new_currency = "EUR";
    } else new_currency = "USD";
    if (new_currency != old_currency)
      $(".price-currency-selector", this.$el).val(new_currency).change();

    // Update flag
    var country_code = $(event.currentTarget)
      .find(":selected")
      .data("country-code");
    var flagSelector = $(".flag-icon", this.$el);
    var img_path = flagSelector.attr("src");
    var new_path = img_path.replace(
      /(.*\/)(.*?)(\.png)/,
      "$1" + country_code + "$3"
    );
    flagSelector.attr("src", new_path);
    $(".price-localisation-selector-container", this.$el).addClass("s_hidden");
    $(".toggle-select-localisation", this.$el).addClass("inline-block");
    $(".toggle-select-localisation", this.$el).removeClass("s_hidden");
  };

  PrintPriceView.prototype.render = function () {
    this.renderTotalLine(); // classic (mode B) total line ("quantity x unit = total" )
    this.renderSummary();
    this.renderCurrencySelectors();
    this.renderQuantityBadge();
    this.toggleAddToCart();
    this.renderProductionModes();
  };

  PrintPriceView.prototype.renderProductionModes = function () {
    this.toggleModeVisibility();
    this.renderProductionMode("standard", PRODUCTION_MODE.STANDARD);
    this.renderProductionMode("economy", PRODUCTION_MODE.ECONOMY);
    this.renderProductionMode("express", PRODUCTION_MODE.FAST);
  };

  PrintPriceView.prototype.renderProductionMode = function (
    mode_class,
    production_mode
  ) {
    var $production_mode = $(".price-" + mode_class, this.$el);
    var $unit_price = $production_mode.find(".price-unit");
    var $undiscounted_unit_price = $(
      ".price-" + mode_class + " .price-undiscounted",
      this.$el
    );
    var $delivery = $production_mode.find("p.price-ships");

    $undiscounted_unit_price.hide();

    var errors = this._overrideProductionModeErrors(
      production_mode,
      PriceDataUtils.getErrors(this.prices, production_mode)
    );

    var is_same_mode = production_mode === this.getSelectedMode();

    $production_mode.toggleClass("selected", is_same_mode);
    $production_mode.toggleClass("disabled", errors.length > 0);

    if (
      is_same_mode &&
      production_mode === PRODUCTION_MODE.ECONOMY &&
      errors.length > 0
    ) {
      console.log(
        "Autoswitch to standard_mode, economy_mode not avalaible with finish",
        this.design.order.finish
      );
      this.controller.notify(
        "warn",
        sculpteo.WARNING.AUTO_SWITCH_STANDARD,
        false
      );

      this.selectProductionMode("standard_mode");
    }

    if (errors.length > 0) {
      var errors_html = errors
        .map(function (error) {
          return gettext(error);
        })
        .join("<br/>");
      $production_mode.find(".disabled_info").html(errors_html);
    } else {
      var unit_price = PriceDataUtils.getUnitPrice(
        this.prices,
        production_mode,
        this.design.order.finish,
        this.design.order.painting
      );
      $unit_price.html(this.formatPrice(unit_price));

      var undiscounted_business_rewards_unit_price =
        PriceDataUtils.getUnitPrice(
          this.prices,
          production_mode,
          this.design.order.finish,
          this.design.order.painting,
          true
        );

      // Show crossed undiscounted price, if benefiting from a discount (2D only)
      // (or if the price has business rewards)
      if (
        this.controller.controllerType === "2D" ||
        undiscounted_business_rewards_unit_price
      ) {
        var undiscounted_unit_price = PriceDataUtils.getUnitPriceNoDiscount(
          this.prices,
          production_mode
        );
        if (undiscounted_business_rewards_unit_price)
          undiscounted_unit_price = undiscounted_business_rewards_unit_price;
        if (undiscounted_unit_price && undiscounted_unit_price !== unit_price) {
          $undiscounted_unit_price
            .html(this.formatPrice(undiscounted_unit_price))
            .show();
        } else {
          $undiscounted_unit_price.hide();
        }
      }

      var delivery = PriceDataUtils.getDelivery(
        this.prices,
        production_mode,
        this.design.order.finish,
        this.design.order.painting
      );
      delivery = delivery ? delivery : "N/A";
      $delivery.find(".receipt-date").text(delivery);
    }
  };

  /**
   * Renders the "Your Selection" summary section
   */
  PrintPriceView.prototype.renderSummary = function () {
    // Process & Material
    var material = $("#select-material option:selected").text();
    var process = $("#select-process option:selected").text();
    var materialDescription = $(
      ".material-description span:first-child",
      this.$el
    );
    var processDescription = $(
      ".process-description span:first-child",
      this.$el
    );

    materialDescription.text(material);
    processDescription.text(process);

    // Infill
    var infill = $("#select-infill option:selected").val();
    var infillContainer = $(".infill-description", this.$el);
    var infillDescription = $(".infill-description span:first-child", this.$el);

    if (infill) {
      var infillValue = infill.split("_")[1];
      infillDescription.text(infillValue + "%");
      infillContainer.show();
    } else {
      infillContainer.hide();
    }

    // Finish
    var finish = $("#select-finish option:selected").text();
    var finishContainer = $(".finish-description", this.$el);
    var finishDescription = $(".finish-description span:first-child", this.$el);

    if (finish) {
      finishDescription.text(finish);
      finishContainer.show();
    } else {
      finishContainer.hide();
    }

    // Color
    finish = $("#select-finish option:selected").val();
    var color = $("#select-color option:selected").text();
    var colorContainer = $(".color-description", this.$el);
    var colorDescription = $(".color-description span:first-child", this.$el);
    var $extradetails = $(".PrintDetailsForm");
    if ($extradetails.length) {
      var custom_color_display = $(
        "input[name=custom_color_display]",
        $extradetails
      ).val();
      var custom_color_code = $(
        "input[name=custom_color_code]",
        $extradetails
      ).val();
      var custom_color_finish = $(
        "input[name=custom_color_finish]:checked",
        $extradetails
      )
        .parent()
        .text()
        .trim();
      var custom_color_operation = $(
        "select[name=custom_color_operation] option:selected",
        $extradetails
      )
        .text()
        .trim();
    }

    if (
      finish &&
      ((finish.startsWith("raw") && !finish.startsWith("raw_epd")) ||
        finish.startsWith("basic"))
    ) {
      colorContainer.hide();
    } else if (!color) {
      colorContainer.hide();
    } else {
      if ($extradetails.length && custom_color_code) {
        var color_swatch = `<span class="color-swatch" style="--color-swatch: ${custom_color_display};">${custom_color_code}</span>`;
        color = `${color} - ${color_swatch} - ${custom_color_finish} - ${custom_color_operation}`;
      }
      colorDescription.html(color);
      colorContainer.show();
    }

    // Size
    var scale = this.design.size.userScale;

    var x = Utils.decimalPrecision(this.design, this.design.size.x * scale);
    var y = Utils.decimalPrecision(this.design, this.design.size.y * scale);
    var z = Utils.decimalPrecision(this.design, this.design.size.z * scale);

    var sizeDescription = $(".size-description span", this.$el);
    sizeDescription.text(
      x + " x " + y + " x " + z + " " + this.design.size.unit
    );

    // Total
    var totalDescription = $(".total-description span:first-child", this.$el);
    var total = PriceDataUtils.getTotalPrice(
      this.prices,
      this.getSelectedMode(),
      this.design.order.finish,
      this.design.order.painting
    );

    // Debug
    var errors = PriceDataUtils.getErrors(this.prices, this.getSelectedMode());
    var $debugView = $(".DebugView").css({ "text-align": "left" });
    $debugView.empty();
    $debugView.append($("<div>").html("Mode: " + this.getSelectedMode()));
    $debugView.append(
      $("<div>").html("Material: " + this.design.material.slug)
    );
    $debugView.append(
      $("<div>").html(
        "Infill: " + (this.design.order.infill ? this.design.order.infill : "")
      )
    );
    $debugView.append(
      $("<div>").html(
        "Finish: " + (this.design.order.finish ? this.design.order.finish : "")
      )
    );
    $debugView.append(
      $("<div>").html(
        "Painting: " +
          (this.design.order.painting ? this.design.order.painting : "")
      )
    );
    $debugView.append($("<div>").html("Errors: " + errors.join("<br/>")));

    if (isNaN(total)) {
      totalDescription.text("---");
    } else {
      var price_text = this.thousandWithSpace(this.formatPrice(total));
      totalDescription.html(price_text);
      if (sculpteo.is_business_rewards) {
        var br_price = PriceDataUtils.getBusinessRewardsPrice(
          this.prices,
          this.getSelectedMode(),
          this.design.order.finish,
          this.design.order.painting
        );
        if (br_price && br_price !== total) {
          $(".total-description .business-rewards", this.$el).html(
            this.thousandWithSpace(this.formatPrice(br_price))
          );
          $(".settings-description").addClass("business-rewards");
          $(".total-description .business-rewards-container").show();
        } else {
          $(".total-description .business-rewards-container").hide();
          $(".settings-description").removeClass("business-rewards");
        }
      }
    }
  };

  PrintPriceView.prototype.renderQuantityBadge = function () {
    var $badge = $(".nav-shopping-badge1");

    // resize the badge to make the value fit nicely
    if (this.design.order.quantity < 10) {
      $badge.css({ "padding-left": "8px", "padding-right": "8px" });
    } else if (this.design.order.quantity > 99) {
      $badge.css({ "padding-left": "4px", "padding-right": "3px" });
    } else {
      $badge.css({ "padding-left": "6px", "padding-right": "6px" });
    }

    $badge.show().text(this.design.order.quantity);
  };

  PrintPriceView.prototype.renderCurrencySelectors = function () {
    $(
      '.price-by-quantity .price-currency-selector option[value="' +
        this.design.order.currency +
        '"]',
      this.$el
    ).prop("selected", true); // old currency select
    $(".print-price-view-currency .currency", this.$el).html(
      this._getCurrencySymbol(this.design.order.currency)
    ); // new currency selector
  };

  /**
   * Update total line (classic (mode B) total)
   */
  PrintPriceView.prototype.renderTotalLine = function () {
    $(".price-unit-selected", this.$el).html(
      this.formatPrice(
        PriceDataUtils.getUnitPrice(
          this.prices,
          this.getSelectedMode(),
          this.design.order.finish,
          this.design.order.painting
        )
      )
    );
    $(".price-total-selected", this.$el).html(
      this.formatPrice(
        PriceDataUtils.getTotalPrice(
          this.prices,
          this.getSelectedMode(),
          this.design.order.finish,
          this.design.order.painting
        ),
        true
      )
    );

    // update the total in modal
    if (this.controller.toggleModalGiveUsACall) {
      this.controller.toggleModalGiveUsACall(this.unitPrice);
    }
  };

  /**
   * when add to cart, change the state of the button to a loading mode
   */
  PrintPriceView.prototype.setAddToCartLoading = function () {
    $(".add-to-cart-button").addClass("loading");
  };

  /**
   * Renders the add to cart button with the correct state depending on current price errors
   */
  PrintPriceView.prototype.toggleAddToCart = function () {
    var hasErrors =
      PriceDataUtils.getErrors(this.prices, this.getSelectedMode()).length > 0;
    $(".add-to-cart-button").attr("disabled", hasErrors);
  };

  /**
   * Update production mode visibility based on the currency
   * @public
   */
  PrintPriceView.prototype.toggleModeVisibility = function () {
    if (this.design.order.currency == "USD") {
      $('[data-mode="fast_mode"]', this.$el).parent().hide();
    } else {
      $('[data-mode="fast_mode"]', this.$el).parent().show();
    }
  };

  PrintPriceView.prototype.toggleNotification = function (error) {
    if (error) {
      $(".mode-a.price-view-settings", this.$el).removeClass("flexbox");
      $(".mode-a.print-price-view-currency", this.$el).removeClass("block");
      $(".print-price-view-currency", this.$el).addClass("hidden");

      $(".price-view-settings", this.$el).addClass("hidden");
      $(".price-view-notification", this.$el).removeClass("hidden");
      $(".price-view-notification", this.$el).addClass("flexbox");
      $(".next-day-notification", this.$el).text(error);
    } else {
      $(".mode-a.price-view-settings", this.$el).addClass("flexbox");
      $(".mode-a.print-price-view-currency", this.$el).addClass("block");
      $(".print-price-view-currency", this.$el).removeClass("hidden");

      $(".price-view-settings", this.$el).removeClass("hidden");
      $(".price-view-notification", this.$el).addClass("hidden");
      $(".price-view-notification", this.$el).removeClass("flexbox");
    }
  };

  PrintPriceView.prototype.toggleLocalisationDisplay = function (event) {
    event.stopPropagation();
    if (event.data.displaySelect) {
      $(".price-localisation-selector-container", this.$el).removeClass(
        "s_hidden"
      );
      $(".toggle-select-localisation", this.$el).removeClass("inline-block");
      $(".toggle-select-localisation", this.$el).addClass("s_hidden");
      $(".price-localisation-selector", this.$el).select2("open");
      return;
    }
    if (!$(event.target).is(".price-localisation-selector")) {
      $(".price-localisation-selector-container", this.$el).addClass(
        "s_hidden"
      );
      $(".toggle-select-localisation", this.$el).addClass("inline-block");
      $(".toggle-select-localisation", this.$el).removeClass("s_hidden");
    }
  };

  PrintPriceView.prototype.toggleCurrencyDisplay = function (event) {
    event.stopPropagation();
    var error_msg;
    if (event.data.displaySelect) {
      // We prevent changing currency if the cart is not empty
      var cartNbItems = parseInt($(".nav-shopping-badge").text());
      if (isNaN(cartNbItems)) {
        // There is no existing cart yet (not logged in user)
        cartNbItems = 0;
      }
      if (cartNbItems !== 0) {
        error_msg = gettext(
          "You have items in your cart, if you would like to change the currency, please empty your cart first."
        );
        return this.toggleCurrencyDisplayErr(error_msg);
      }
      $(".toggle-select-currency", this.$el).hide();
      $(".price-currency-selector-container", this.$el).show();
      $(
        ".price-currency-selector-container > .price-currency-selector"
      ).select2("open");
    } else if (!$(event.target).is(".price-currency-selector")) {
      $(".toggle-select-currency", this.$el).show();
      $(
        ".price-currency-selector-container > .price-currency-selector-container",
        this.$el
      ).hide();
    }
  };

  PrintPriceView.prototype.toggleCurrencyDisplayErr = function (error) {
    $(".tooltip-currency-change-err").text(gettext(error)).show();
    setTimeout(function () {
      $(".tooltip-currency-change-err").hide();
    }, 5000);
  };

  PrintPriceView.prototype._getCurrencySymbol = function (currency_code) {
    var symbols = { USD: "$", EUR: "€", GBP: "£" };
    if (!symbols.hasOwnProperty(currency_code)) {
      console.warn("Invalid currency code", currency_code);
      return null;
    }
    return symbols[currency_code];
  };

  PrintPriceView.prototype.thousandWithSpace = function (price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  /**
   * Format price with the good decimal separator and currency symbol
   * @private
   * @param {float} price
   */
  PrintPriceView.prototype.formatPrice = function (price, withoutCurrency) {
    return this.controller.formatPrice(price, withoutCurrency);
  };

  PrintPriceView.prototype.getQuoteForm = function (event) {
    this.controller.showModalQuote([
      {
        url: $("#PrintModalQuote").find("input[name=url]").val(),
        material: $(".material-description td").text(),
        finish: $(".finish-description td").text(),
        quantity: $(event.target)
          .closest(".price-quantity-line")
          .find(".quantity-cell")
          .text(),
      },
    ]);
  };
})((window.sculpteo = window.sculpteo || {}));
